import React, { Fragment, useEffect, useState } from "react";
import "../../assets/css/sap-master/sap-master.css";
import SearchIcon from "@mui/icons-material/Search";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import {
  Button,
  DialogActions,
  Grid,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import TextFiealdInput from "../components/textFiald";
import {
  addGroupDataData,
  clearGroupDataData,
} from "../../redux/sap-master/group-master-active-data-reducer";
import {
  business_channel_is_first,
  list_business_channel,
} from "../../redux/prefered-master/business-channel-list";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import AutoComplete from "../components/autocomplete-input";

import CompletePopup from "../components/response-pop-up";
import { list_role } from "../../redux/add-user/list-role";
import {
  add_user,
  add_user_is_success,
  create_user_complete_api,
} from "../../redux/add-user/add-user";
import { list_user, user_is_first } from "../../redux/add-user/list-user";
import {
  edit_user,
  edit_user_complete_api,
  edit_user_is_success,
} from "../../redux/add-user/edit-user";
import SearchImg from "../../assets/images/search.svg";
import DataNotFound from "../../assets/images/no_data_found.svg";
import { useCommonContext } from "../../Utils/commonContext";
const AddUser = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [edit, setEdit] = useState<boolean>(false);
  const [responsePopup, setResponsePopup] = useState<boolean>(false);
  const [responseEdit, setResponseEdit] = useState<boolean>(false);
  const roleList = useSelector((state: any) => state.ListRole);
  const addUserApi = useSelector((state: any) => state.AddUser);
  const editUserApi = useSelector((state: any) => state.editUser);
  const [activePartner, setActivePartner] = React.useState<number | null>(null);
  const [search, setSearch] = useState<string>("");
  const activeDatas = useSelector((state: any) => state.GroupMasterActiveData);
  const activeData = activeDatas.data;
  const { setTitleContext, setShowBack, setOnBackClick, isMobile } =
    useCommonContext();

  const list_users = useSelector((state: any) => state.ListUser);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const validationSchema = Yup.object().shape({
    department: Yup.string().required("Required"),
    name: Yup.string().required("Required"),
    employee_id: Yup.string().required("Required"),
    role: Yup.string().required("Required"),
    reporting_manager: Yup.string().required("Required"),
    location: Yup.string().required("Required"),
    email: Yup.string().email("email is invalid").required("Required"),
    password: Yup.string().required("Required"),
    telephone: Yup.number().required("Required"),
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      department: edit ? activeData.department : "",
      name: edit ? activeData.name : "",
      employee_id: edit ? activeData.employee_id : "",
      role: edit ? activeData.roleId : "",
      reporting_manager: edit ? activeData.reporting_manager : "",
      email: edit ? activeData.email : "",
      location: edit ? activeData.location : "",
      password: "",
      telephone: edit ? activeData.telephone : "",
      active: edit ? activeData.active : "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      submit(values);
    },
  });
  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
    setFieldValue,
    setFieldTouched,
    resetForm,
    errors,
  } = formik;
  // useEffect
  useEffect(() => {
    dispatch(list_user(""));
    dispatch(list_role(""));
    if (addUserApi.isSuccess) {
      resetForm();
      handleClose();
      dispatch(add_user_is_success(""));
    }
    if (editUserApi.isSuccess) {
      resetForm();
      handleClose();
      dispatch(edit_user_is_success(""));
    }
    if (addUserApi.api_completed) {
      setResponsePopup(true);
      dispatch(create_user_complete_api(false));
    }
    if (editUserApi.api_completed) {
      setResponseEdit(true);
      dispatch(edit_user_complete_api(false));
      setResponsePopup(true);
    }
  }, [addUserApi, editUserApi]);

  const submit = (a: any) => {
    const role = roleList.data.result.filter((e: any) => {
      if (a.role === e.role_name) {
        return e;
      }
    });
    const report_manager = list_users.data.result.filter((e: any) => {
      if (a.reporting_manager === e.name) {
        return e;
      }
    });
    if (!edit) {
      const data = {
        department: a.department,
        name: a.name,
        employee_id: a.employee_id,
        active: a.active,
        role: a.role,
        reporting_manager: a.reporting_manager,
        email: a.email.toLowerCase(),
        location: a.location,
        password: a.password,
        telephone: a.telephone,
      };
      dispatch(add_user(data));
    } else {
      const data = {
        id: activeData.id,
        department: a.department,
        name: a.name,
        employee_id: a.employee_id,
        role: a.role,
        active: a.active,
        reporting_manager: a.reporting_manager,
        email: a.email.toLowerCase(),
        location: a.location,
        password: a.password,
        telephone: a.telephone,
      };
      dispatch(edit_user(data));
    }
  };

  const handleBack = () => {
    dispatch(clearGroupDataData());
    setActivePartner(null);
    setShowBack(false);
    setTitleContext("Add User");
  };

  useEffect(() => {
    setOnBackClick(() => handleBack);
    return () => {
      dispatch(clearGroupDataData());
      setShowBack(false);
      setTitleContext("");
    };
  }, []);

  useEffect(() => {
    if (activeData?.name) {
      setShowBack(true);
    }
  }, [activeData]);

  useEffect(() => {
    setTitleContext(activeData.name ?? "Add User");
  }, [activeData]);

  // mainTable data
  const mainTable = () => {
    const filterarr = [];
    if (list_users.data.length != 0) {
      for (let i = 0; i < list_users.data.result.length; i++) {
        let data = { ...list_users.data.result[i] };
        const monthNames = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];

        // create on
        const created_on = new Date(data.created_on);
        // delete data.EffecDate;
        const created_date =
          created_on.getDate() +
          "-" +
          monthNames[created_on.getMonth()] +
          "-" +
          created_on.getFullYear();
        data.created_on
          ? (data.created_on = created_date)
          : console.log("sdfdsf");
        filterarr.push(data);
      }
    }
    // filterarr.filter((e) => delete e.id);
    // filterarr.filter((e) => delete e.active);
    filterarr.filter((e) => delete e.created_by);
    filterarr.filter((e) => delete e.updated_by);

    return (
      <Fragment>
        <div className="content_container">
          {responsePopup ? (
            <CompletePopup
              data={responseEdit ? editUserApi : addUserApi}
              responsePopup={responsePopup}
              setCompletePopup={(e: any) => {
                setResponsePopup(false);
                setResponseEdit(false);
              }}
            />
          ) : (
            ""
          )}
          <div
            className={`mini_side_container`}
            style={{
              display:
                isMobile && typeof activePartner === "number"
                  ? "none"
                  : "initial",
            }}
          >
            <h5 className="f4 primary_text" style={{ paddingBottom: "10px" }}>
              Add User
            </h5>

            <div className="side_search_container">
              <TextField
                autoComplete="off"
                autoCorrect="off"
                spellCheck={false}
                placeholder="Search"
                className="side_search"
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={SearchImg} alt="search" width="20px" />
                    </InputAdornment>
                  ),
                  style: {
                    borderRadius: "0px",
                    height: "45px",
                  },
                }}
              />
              <Button
                className="side_filter"
                disableRipple
                onClick={() => {
                  dispatch(list_business_channel(""));
                }}
              >
                <FontAwesomeIcon
                  style={{
                    fontSize: "22px",
                    color: "var(--white-color)",
                  }}
                  icon={["fas", "arrows-rotate"]}
                />
              </Button>

              <Button
                className="side_filter"
                disableRipple
                onClick={() => {
                  setEdit(false);
                  handleClickOpen();
                }}
              >
                <FontAwesomeIcon
                  style={{
                    fontSize: "22px",
                    color: "var(--white-color)",
                  }}
                  icon={["fas", "add"]}
                />
              </Button>
            </div>

            <div className="side_content_container">
              {filterarr
                .filter((item: any) => {
                  return Object.values(item)
                    .join("")
                    .toLowerCase()
                    .includes(search.toLowerCase());
                })
                .map((e: any, key: number) => {
                  if (list_users.isFirst && key === 0) {
                    dispatch(user_is_first(""));
                  }
                  return (
                    <div
                      key={key + 1}
                      onClick={(a) => {
                        setActivePartner(key);
                        dispatch(addGroupDataData(e));
                      }}
                      className={`side_content_card`}
                    >
                      <div
                        className={`side_content_mini_card ${
                          activePartner === key ? "active" : ""
                        }`}
                      >
                        <div className="f4 title">{e.name}</div>
                        <div className="side_content_footer">
                          <h4 className="f4 subtitle">{e.email}</h4>
                          {/* <h4>{e.status}</h4> */}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>

          <div
            className={`mini_content_container`}
            style={{
              display:
                isMobile && typeof activePartner !== "number"
                  ? "none"
                  : "initial",
            }}
          >
            {typeof activePartner !== "number" ? (
              <div className="not_found_container">
                <img src={DataNotFound} alt="" />
                Please Select Any One User
              </div>
            ) : (
              <Fragment>
                <div className="content_header justify-content-end">
                  <div className="btns">
                    <Button
                      className="common_btn_outline"
                      disableRipple
                      onClick={() => {
                        setEdit(true);
                        handleClickOpen();
                      }}
                    >
                      Edit User
                      <FontAwesomeIcon
                        icon="edit"
                        title="Edit partner onboarding"
                      />
                    </Button>
                  </div>
                </div>

                <div className="scroll_content_container scroll_content_container_2">
                  <div className="grid_container">
                    <div className="detail_item">
                      <label> Name</label>
                      <p>{activeData.name}</p>
                    </div>
                    <div className="detail_item">
                      <label>Email</label>
                      <Tooltip title={activeData.email}>
                        <p className="text_ellipsis">{activeData.email}</p>
                      </Tooltip>
                    </div>
                    <div className="detail_item">
                      <label> Employee Id</label>
                      <p>{activeData.employee_id ?? "--"}</p>
                    </div>
                    <div className="detail_item">
                      <label>Reporting Manager</label>
                      <p>
                        {activeData.reporting_manager
                          ? activeData.reporting_manager
                          : "--"}
                      </p>
                    </div>
                    <div className="detail_item">
                      <label>Location</label>
                      <p>{activeData.location ?? "--"}</p>
                    </div>
                    <div className="detail_item">
                      <label>Role Id</label>
                      <p>{activeData.roleId ?? "--"}</p>
                    </div>
                    <div className="detail_item">
                      <label>Sequence Code</label>
                      <p>{activeData.active ? "Active" : "inActive"}</p>
                    </div>

                    <div className="detail_item">
                      <label>Create On</label>
                      <p>{activeData.created_on}</p>
                    </div>
                  </div>
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </Fragment>
    );
  };
  const pageOption = roleList.data.status
    ? list_users.data.length != 0
      ? roleList.data.result.map((e: any) => {
          const data = { id: e.id, label: e.role_name, value: e.id };
          return data;
        })
      : [{ label: "No Page", value: "no Page" }]
    : [{ label: "No Page", value: "no Page" }];
  const reportManager = roleList.data.status
    ? list_users.data.length != 0
      ? list_users.data.result.map((e: any) => {
          const data = { id: e.id, label: e.name, value: e.id };
          return data;
        })
      : [{ label: "No Page", value: "no Page" }]
    : [{ label: "No Page", value: "no Page" }];
  return (
    <Fragment>
      <div className="partner-details">
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={roleList.isLoading || list_users.isLoading ? true : false}
        >
          {/* <CircularProgress color="inherit" /> */}
          <img
            style={{
              height: "100px",
            }}
            src={require("../../assets/images/3.gif")}
          ></img>
        </Backdrop>
        {mainTable()}
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={"md"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className="dialog_header common_border_bottom">
          <h4 id="alert-dialog-title" className="f4">
            {"Add User"}
          </h4>

          <CancelIcon
            onClick={() => {
              handleClose();
            }}
          />
        </div>
        <DialogContent>
          <Grid container rowSpacing={3} columnSpacing={3}>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <TextFiealdInput
                name="name"
                label="Name"
                handleBlur={handleBlur}
                handleChange={handleChange}
                values={values}
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <TextFiealdInput
                name="department"
                label="Department"
                handleBlur={handleBlur}
                handleChange={handleChange}
                values={values}
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <AutoComplete
                className="w-100"
                pageOption={pageOption}
                name="role"
                handleBlur={handleBlur}
                values={values}
                vari={(e: any) => {
                  setFieldValue("role", e ? e.value : "");
                }}
                label="Role"
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <AutoComplete
                className="w-100"
                pageOption={reportManager}
                name="reporting_manager"
                handleBlur={handleBlur}
                values={values}
                vari={(e: any) => {
                  setFieldValue("reporting_manager", e ? e.value : "");
                }}
                label="Reporting Manger"
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <TextFiealdInput
                name="employee_id"
                label="Employee Id"
                handleBlur={handleBlur}
                handleChange={handleChange}
                values={values}
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <TextFiealdInput
                name="email"
                label="Email"
                handleBlur={handleBlur}
                handleChange={(e: any) => {
                  setFieldValue("email", e.target.value.toLowerCase());
                }}
                values={values}
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <TextFiealdInput
                name="location"
                label="Location"
                handleBlur={handleBlur}
                handleChange={handleChange}
                values={values}
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <TextFiealdInput
                name="password"
                label="Password"
                handleBlur={handleBlur}
                handleChange={handleChange}
                values={values}
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <TextFiealdInput
                name="telephone"
                label="Telephone"
                handleBlur={handleBlur}
                handleChange={handleChange}
                values={values}
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <div className="field_item">
                <FormControlLabel
                  value={values.active}
                  control={<Checkbox checked={values.active} />}
                  label="Is Active"
                  onChange={handleChange}
                  name="active"
                  labelPlacement="end"
                />
              </div>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <div className="dialog_footer">
            <Button
              disableRipple
              className="common_btn_outline"
              onClick={() => {
                handleClose();
                //   setIsEdit(false);
              }}
            >
              Cancel
            </Button>
            <Button
              className="common_btn"
              disableRipple
              onClick={() => {
                handleSubmit();
              }}
            >
              {addUserApi.isLoading ? "Please Wait" : "Save"}
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default AddUser;
